<template>
  <ve-table style="width: 100%;" :scroll-width="scrollWidth" :columns="columns" :table-data="tableData"
    row-key-field-name="keyName" :rowStyleOption="{ stripe: true }" />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    scrollWidth: {
      type: Number,
      require: true
    },
    keyName: {
      type: String,
      require: true
    },
    tableData: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters([
      'achievementRate'
    ]),
    columns() {
      return [
        {
          field: '',
          key: 'expand',
          title: '',
          width: 30,
          align: 'center',
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.isLeaf ? '' : h('div', {
              style: {
                'font-size': '16px',
                position: 'relative',
                top: '-2px'
              },
              on: {
                click: () => {
                  this.$emit('on-expand', row, rowIndex)
                }
              }
            }, row.canExpand ? (row.isExpand ? '-' : '+') : '')
          }
        },
        {
          title: '线路',
          key: 'callLine',
          tree: true,
          fixed: 'left',
          align: 'left',
          width: 90,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', {
              style: {
                position: 'relative',
                left: row.isLeaf ? '10px' : 0
              }
            }, row.teamName || row.callLine || '未知')
          }
        },
        {
          title: '接通率',
          key: 'connRate',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const percent = Number(row.connRate * 100).toFixed(2)
            return h('span', `${percent}%`)
          }
        },
        {
          title: '呼叫量',
          key: 'callCnt',
          field: 'callCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '接通量',
          key: 'connCnt',
          field: 'connCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '呼叫受限',
          key: 'callRestrictedCnt',
          field: 'callRestrictedCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '线路限制',
          key: 'userUnreachableCnt',
          field: 'userUnreachableCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '空号',
          key: 'emptyNumberCnt',
          field: 'emptyNumberCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '欠费未接听',
          key: 'unansweredCnt',
          field: 'unansweredCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '用户关机',
          key: 'calledToShutDownCnt',
          field: 'calledToShutDownCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '用户拒接',
          key: 'userRejectsCnt',
          field: 'userRejectsCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '用户未接听',
          key: 'notAnswerCnt',
          field: 'notAnswerCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '用户未响应',
          key: 'userUnaccessCnt',
          field: 'userUnaccessCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '坐席未接听',
          key: 'agentTimeoutCnt',
          field: 'agentTimeoutCnt',
          width: 80,
          align: 'center'
        }
      ]
    }
  }
}
</script>
